import { TYPE_STRING } from './input-types';

export const id = 'company';
export const apiKey = 'ShipToCompany';
export const type = TYPE_STRING;

export const company = {
  id,
  apiKey,
  type,
};
